import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/cross';
import Tooltip from '@atlaskit/tooltip';
import { css } from '@compiled/react';
import { AdControls } from '@post-office/components--ad-controls';
import { usePostOfficeUserInteractions } from '@atlassian/post-office-analytics/interactions';
import { useMessageEvent } from '@post-office/message-lifecycle';
import { type ComponentProps, type FunctionComponent } from 'react';
import { useIntl } from 'react-intl';

type PropsWithOnDismissed = {
	onDismissed: () => void;
	whyAmISeeingThisModalContent?: ComponentProps<typeof AdControls>['whyAmISeeingThisModalContent'];
};

const DismissButton: FunctionComponent<PropsWithOnDismissed> = ({ onDismissed }) => {
	const { messageDismissed } = useMessageEvent();
	const { onClosed } = usePostOfficeUserInteractions();

	const intl = useIntl();
	const tooltip = intl.formatMessage({
		id: 'post-office.close-button.tooltip',
		defaultMessage: 'Close',
		description:
			'Tooltip text displayed on the dismiss/close button in the banner message actions area',
	});

	return (
		<Tooltip content={tooltip}>
			<IconButton
				shape="default"
				appearance="subtle"
				label="close"
				icon={(iconProps) => <CrossIcon {...iconProps} size="small" />}
				onClick={() => {
					onDismissed();
					messageDismissed().catch(() => {});
					void onClosed({
						interactionIdentifier: 'close',
						additionalMetadata: {},
					});
				}}
			/>
		</Tooltip>
	);
};

const actionsStyles = css({
	display: 'flex',
});

export const Actions: FunctionComponent<PropsWithOnDismissed> = ({
	onDismissed,
	whyAmISeeingThisModalContent,
}) => {
	return (
		<div css={actionsStyles}>
			<AdControls
				iconSize="small"
				onDismissed={onDismissed}
				showWhyAmISeeingThis={true}
				whyAmISeeingThisModalContent={whyAmISeeingThisModalContent}
			/>
			<DismissButton onDismissed={onDismissed} />
		</div>
	);
};
